module.exports = __webpack_public_path__ + "staticcomp/img/article_top_bt2.7ba372b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/article_top_bt2.png
// module id = dPsL
// module chunks = 39